import { render, staticRenderFns } from "./update-mapping.vue?vue&type=template&id=79b9beba&scoped=true"
import script from "./update-mapping.vue?vue&type=script&lang=js"
export * from "./update-mapping.vue?vue&type=script&lang=js"
import style0 from "./update-mapping.vue?vue&type=style&index=0&id=79b9beba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b9beba",
  null
  
)

export default component.exports